import { createContext, useContext } from 'react';

export type TAppContext = {
  viewScope?: string;
};
export const AppContext = createContext<TAppContext>({});
export const useAppContext = () => useContext(AppContext);
